import { BookOpen, FlaskConical, Video, ExternalLink, FileText, Upload, Presentation, ClipboardList } from 'lucide-react';

const LAB_TYPES = ['learning_lab', 'ai_learning_lab', 'existing_lab'];

export const ACTIVITY_META = {
  course: { label: 'Learning Unit', icon: BookOpen, color: '#14b8a6', action: 'Start Learning Unit' },
  ai_course: { label: 'Learning Unit', icon: BookOpen, color: '#14b8a6', action: 'Start Learning Unit' },
  existing_course: { label: 'Learning Unit', icon: BookOpen, color: '#14b8a6', action: 'Start Learning Unit' },
  lab: { label: 'Learning Lab', icon: FlaskConical, color: '#8b5cf6', action: 'Open Lab' },
  video: { label: 'Video', icon: Video, color: '#3b82f6', action: 'Watch' },
  masterclass: { label: 'Masterclass', icon: Presentation, color: '#ec4899', action: 'Open Masterclass' },
  aicc: { label: 'External Module', icon: ExternalLink, color: '#06b6d4', action: 'Open' },
  document: { label: 'Reading', icon: FileText, color: '#a1a1aa', action: 'Download Reading' },
  assignment_brief: { label: 'Assignment Brief', icon: Upload, color: '#f59e0b', action: 'Download Brief' },
  assignment: { label: 'Assignment', icon: ClipboardList, color: '#f59e0b', action: 'Open Assignment' },
};

export const dueState = (iso) => {
  if (!iso) return null;
  const hours = (new Date(iso) - Date.now()) / 36e5;
  return hours < 0 ? 'overdue' : hours <= 72 ? 'soon' : 'open';
};

export const DUE_STYLES = {
  open: 'bg-green-500/15 text-green-300 border-green-500/30',
  soon: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  overdue: 'bg-red-500/15 text-red-300 border-red-500/30',
};

export const formatDue = (iso) => new Date(iso).toLocaleString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const activityMeta = (a) => {
  if (a.content_type === 'learning_lab' || LAB_TYPES.includes(a.activity_type)) return ACTIVITY_META.lab;
  return ACTIVITY_META[a.activity_type] || { label: (a.activity_type || 'Activity').replace(/_/g, ' '), icon: FileText, color: '#a1a1aa', action: 'Open' };
};

// In-app path that opens an activity; course/lab players get programme context for "Up next".
export const activityLaunchPath = (a, programmeId) => {
  const ctx = `?programme=${programmeId}&activity=${a.activity_id}`;
  if (a.activity_type === 'assignment') return `/programmes/${programmeId}/assignments/${a.activity_id}`;
  if (a.content_type === 'learning_lab' || LAB_TYPES.includes(a.activity_type)) return a.content_id ? `/labs/${a.content_id}${ctx}` : null;
  if (['course', 'ai_course', 'existing_course'].includes(a.activity_type)) {
    const id = a.ai_course_id || a.content_id;
    return id ? `/courses/${id}/learn${ctx}` : null;
  }
  if (a.activity_type === 'masterclass' && a.content_id) return `/masterclasses/${a.content_id}`;
  return null;
};
